<template>
  <div>
    <div class="title-month">
      <label class="year">{{ yearStr }}年</label>
      <label class="month">{{ monthStr }}月</label>
      <v-menu v-if="navs.length == 0" v-model="menu" :close-on-content-click="false" :nudge-right="40"
        transition="scale-transition" offset-y min-width="290px">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">arrow_drop_down</v-icon>
        </template>
        <v-date-picker v-model="month" color="primary" locale="zh-cn" type="month" @input="menu = false">
        </v-date-picker>
      </v-menu>
    </div>
    <div v-if="navs.length > 0" class="nav">
      <label @click="goNav(-1)" class="active">首页</label>
      <label :class="{ active: idx < navs.length - 1 }" @click="goNav(idx)" v-for="(nav, idx) in navs" :key="nav.n">
        > {{ nav.n }}</label>

      <span class="desc">
        <v-icon :size="16" color="orange">info</v-icon>可点击左边<b>蓝色连接</b>可以返回
      </span>
    </div>
    <mo-clazz-chart v-if="month" :month="month" @loc_click="onLocClick" v-show="navs.length == 0" />
    <component @loc_click="onLocClick" v-for="(nav, idx) in navs" :key="nav.n" :is="nav.comp" :loc="nav.loc"
      v-show="idx == navs.length - 1" :month="month" />
  </div>
</template>
<script>
import MoClazzChart from "./mo-clazz-chart.vue";
export default {
  name: "mo-clazz-dash",
  components: {
    "mo-clazz-chart": MoClazzChart,
  },
  data() {
    return {
      menu: false,
      month: null,
      yearStr: "",
      monthStr: "",
      navs: [],
    };
  },
  watch: {
    month(n) {
      this.yearStr = n.substring(0, 4);
      this.monthStr = n.substring(5, 7);
    },
  },
  methods: {
    goNav(idx) {
      let self = this,
        navs = self.navs;
      idx += 1;
      navs.splice(idx, navs.length - idx);
    },
    onLocClick(r) {
      let self = this,
        navs = self.navs;
      navs.push({ n: r.name, comp: MoClazzChart, loc: r.id });
    },
    init() {
      let self = this,
        month = new Date().toISOString().substr(0, 7);
      self.month = month;
      self.yearStr = month.substring(0, 4);
      self.monthStr = month.substring(5, 7);
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
.title-month {
  text-align: center;
}

.title-month .year {
  color: #5470c6;
}

.title-month .month {
  color: #ea7ccc;
  font-size: 18px;
  font-weight: bold;
}

.nav {
  padding-bottom: 16px;
  font-size: 10px;
  color: #9e9e9e;
}

.nav label.active {
  cursor: pointer;
  color: #0068b7;
}

.nav .desc {
  float: right;
  color: orange;
}
</style>
